module.exports = __webpack_public_path__ + "sit/20260418112858/img/logo_200.6488dd39.png";